<div>
    <img [src]="qrCodeImageUrl[0]" alt="QR Code" width="320" height="320">
    <div class="paginator-and-button-container">
        <button mat-menu-item type="button"  (click)="downloadQRcode()">
          <mat-icon>cloud_download</mat-icon>
          {{ "common.qrcode.download" | translate }}
        </button>
      </div>
</div>